export const FIELDS = {
  ID: 'id',
  COMPANY_ID: 'companyId',
  COMPANY_NAME: 'companyName',
  IS_PRIMARY: 'isPrimary',
  TITLE: 'title',
  LOCATION: 'location',
  LOCATION_PHONE: 'locationPhone',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  FULL_NAME: 'fullName',
  GENDER: 'gender',
  DOB: 'dob',
  EMAIL1: 'email1',
  EMAIL2: 'email2',
  MAIN: 'main',
  DIRECT: 'direct',
  MOBILE: 'mobile',
  PHONE1_TYPE_ID: 'phone1TypeId',
  PHONE1_TYPE_NAME: 'phone1TypeName',
  PHONE1: 'phone1',
  PHONE1_EXT: 'phone1Ext',
  PHONE2_TYPE_ID: 'phone2TypeId',
  PHONE2_TYPE_NAME: 'phone2TypeName',
  PHONE2: 'phone2',
  PHONE2_EXT: 'phone2Ext',
  COMMENT: 'comment',
  ACCOUNTING: 'accounting',
  PURCHASING: 'purchasing',
  SALES: 'sales',
  DO_NOT_EMAIL: 'doNotEmail',
  DO_NOT_CALL: 'doNotCall',
  LINKIN: 'linkin',
  SKYPE: 'skype',
  TWITTER: 'twitter',
  FACEBOOK: 'facebook',
  XING: 'xing',
  USER_ID: 'userId',
  CREATED_BY_USER_ID: 'createdByUserId',
  CREATED_BY_USER_FULL_NAME: 'createdByUserFullName',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  MODIFIED_BY_USER_FULL_NAME: 'modifiedByUserFullName',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  ACTIVE: 'active',
  TASK_TYPE: 'taskType',
  TASK_STATUS: 'taskStatus',
  TASK_PRIORITY: 'taskPriority',
  TASK_SUBJECT: 'taskSubject',
  TASK_DUE: 'taskDue',};